const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/warehouse",
  },
  actions: {
    // Warehouse operations
    getWarehouses({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    getWarehouse({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/id/${options._id}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    addWarehouse({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    saveWarehouse({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/save`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    removeWarehouse({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/delete`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },

    // Group operations
    getGroups({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/groups?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    getGroup({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/groups/${options._id}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    addGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    saveGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/save-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    removeGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/delete-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },

    // Item operations
    getItems({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/items?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    addBookProduct({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add-book-product`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    getProduct({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/product/${options._id}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },

    // Supplier operations
    getSuppliers({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/suppliers?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    addSupplier({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add-supplier`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    editSupplier({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/edit-supplier`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    removeSupplier({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/delete-supplier`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
  },
};
